var PRIMEDefaultCohort2 = {
  "name": "DCCT intensive",
  "note": "",
  "version": 1,
  "project": null,
  "references": "Nathan et al. Diabetes control and complications trial/epidemiology of diabetes interventions and complications study at 30 years: advances and contributions. Diabetes. 2013;62(12):3976-86.",
  "male": {
  "proportion": 51.5
},
  "smokers": {
  "proportion": 18.5
},
  "takingAntiHypertensiveMedication": {
  "proportion": 3.1
},
  "takingAntiThromboticMedication": {
  "proportion": 0
},
  "takingPrimaryLipidModifyingMedication": {
  "proportion": 0
},
  "takingSecondaryLipidModifyingMedication": {
  "proportion": 0
},
  "age": {
  "mean": 27.2,
    "sd": 7.1
},
  "durationOfDiabetesAtBaseline": {
  "mean": 5.8,
    "sd": 4.2
},
  "hbA1c": {
  "mean": 9.1,
    "sd": 1.6
},
  "sbp": {
  "mean": 114.5,
    "sd": 11.3
},
  "totalCholesterolMmolL": {
  "mean": 4.57981,
    "sd": 0.84821
},
  "ldlmmolL": {
  "mean": 2.85236,
    "sd": 0.74218
},
  "hdlmmolL": {
  "mean": 1.31369,
    "sd": 0.31808
},
  "bmi": {
  "mean": 23.4,
    "sd": 2.7
},
  "neuropathyAtBaseline": {
  "proportion": 6.8
},
  "cardioVascularDiseaseAtBaseline": {
  "proportion": 0
},
  "macularEdemaAtBaseline": {
  "proportion": 0
},
  "cHFAtBaseline": {
  "proportion": 0
},
  "amputationAtBaseline": {
  "proportion": 0
},
  "retinopathyAtBaseline": {
  "stateProportionMap": {
    "NO": 83.9,
      "MILD_NPDR": 11.6,
      "MODERATE_NPDR": 4.5,
      "SEVERE_NPDR": 0,
      "PDR": 0,
      "SVL": 0
  }
},
  "renalStateDistributionAtBaseline": {
  "stateProportionMap": {
    "NORMAL": 88.3,
      "MICROALBUMINURIA": 11.7,
      "OVERT": 0,
      "ESRD": 0
  }
},
  "creationDate": 1528842282566,
  "creator": "pollock@ossianconsulting.com"
}
